'use client';

import { useState } from 'react';
import ButtonComponent, { ButtonSizes, ButtonVariants, BUTTON_STATES } from '@pixum/button';
import { logger } from 'utils';
import { loadImagesAndPrint } from './utils';
import styles from './PrintButton.module.css';

interface PrintButtonProps {
  label: string;
}

export function PrintButton({ label }: PrintButtonProps) {
  const [isPreparing, setIsPreparing] = useState(false);

  async function handlePrint() {
    if (isPreparing) return;
    setIsPreparing(true);

    try {
      await loadImagesAndPrint();
    } catch (err) {
      logger.error({ err }, 'Print preparation failed');
    } finally {
      setIsPreparing(false);
    }
  }

  return (
    <div className={`center--content print-button__wrapper ${styles.wrapper}`}>
      <ButtonComponent
        type="button"
        label={label}
        variant={ButtonVariants.SECONDARY}
        size={ButtonSizes.MEDIUM}
        state={isPreparing ? BUTTON_STATES.BUSY : BUTTON_STATES.DEFAULT}
        onClick={handlePrint}
      >
        {label}
      </ButtonComponent>
    </div>
  );
}
